var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3076_550)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3076_550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 49.5V1.5H1.5V49.5H49.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3076_550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5361 24.627C38.7616 23.4016 38.7616 21.4145 37.5361 20.189C36.3107 18.9636 34.3236 18.9636 33.0982 20.189C31.7435 21.5447 30.0159 23.2713 28.6603 24.627C27.4349 25.8524 27.4349 27.8395 28.6603 29.0649C29.8865 30.2904 31.8729 30.2904 33.0982 29.0649C34.4539 27.7093 36.1813 25.9826 37.5361 24.627Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8648 30.1741C42.0902 28.9487 42.0902 26.9616 40.8648 25.7361C39.6395 24.5107 37.6523 24.5107 36.427 25.7361L33.0982 29.0648C31.8729 30.2902 31.8729 32.2765 33.0982 33.5027C34.3236 34.7281 36.3107 34.7281 37.5361 33.5027C38.5796 32.4586 39.8214 31.2175 40.8648 30.1741Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1928 35.7214C44.4843 35.4301 44.7155 35.0843 44.8733 34.7036C45.0311 34.3229 45.1122 33.9149 45.1122 33.5028C45.1123 33.0906 45.0312 32.6824 44.8734 32.3016C44.7157 31.9208 44.4844 31.5748 44.1928 31.2834C43.9014 30.9921 43.5556 30.761 43.1749 30.6034C42.7942 30.4457 42.3862 30.3647 41.9742 30.3647C41.5622 30.3647 41.1542 30.4458 40.7735 30.6034C40.3928 30.761 40.0469 30.9921 39.7556 31.2834C39.0154 32.0228 38.2756 32.7626 37.5362 33.5028C37.2449 33.7942 37.0139 34.1401 36.8563 34.5207C36.6987 34.9014 36.6176 35.3094 36.6177 35.7214C36.6176 36.1334 36.6987 36.5414 36.8563 36.922C37.0139 37.3027 37.2449 37.6486 37.5362 37.9399C37.8276 38.2315 38.1736 38.4628 38.5544 38.6206C38.9352 38.7783 39.3434 38.8595 39.7556 38.8594C40.1677 38.8594 40.5757 38.7782 40.9564 38.6205C41.3371 38.4627 41.683 38.2315 41.9742 37.9399L44.1928 35.7214Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.098 20.1889C33.098 20.1889 37.9228 15.3649 40.8646 12.4231C41.453 11.8343 41.7834 11.036 41.7834 10.2037C41.7835 9.7917 41.7024 9.3837 41.5447 9.00304C41.3871 8.62237 41.156 8.27649 40.8646 7.98516C40.5733 7.69365 40.2274 7.4624 39.8467 7.30463C39.4659 7.14686 39.0578 7.06565 38.6457 7.06565C38.2336 7.06565 37.8255 7.14686 37.4447 7.30463C37.064 7.4624 36.7181 7.69365 36.4268 7.98516L19.7851 24.6269C19.7851 24.6269 19.0845 21.5932 18.3266 18.3076C18.1416 17.5058 17.7453 16.7681 17.1788 16.1712C16.6124 15.5743 15.8965 15.1399 15.1055 14.9131C14.3146 14.6862 13.4773 14.6752 12.6807 14.8813C11.8841 15.0874 11.1573 15.5031 10.5757 16.0852C10.5749 16.0852 10.5749 16.0859 10.5749 16.0859L10.5938 34.9141L5.88672 39.6211L15.3008 49.0352H28.93C29.5481 49.035 30.1601 48.9132 30.7311 48.6765C31.3021 48.4399 31.8208 48.0931 32.2578 47.656C35.6626 44.2521 44.1925 35.7213 44.1925 35.7213",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7852 24.627L20.8944 25.7363C23.9579 28.7997 23.9579 33.7672 20.8944 36.8307",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0078 8.24097V1.96489",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.732 8.24097L12.1631 6.67202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2837 8.24097L27.8526 6.67202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3076_550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.94976c7e10417f62f1bed5892da9d513.svg";
export { ForwardRef as ReactComponent };